import { render, staticRenderFns } from "./HealthRoomReceptionRegist.vue?vue&type=template&id=070f42a6"
import script from "./HealthRoomReceptionRegist.vue?vue&type=script&lang=js"
export * from "./HealthRoomReceptionRegist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports